import { SOCIAL_MEDIA } from "../utils/constants";
 export const socialMediaMixin = {
  data() {
    return {
      iconX: SOCIAL_MEDIA.X.classIcon,
      iconFB: SOCIAL_MEDIA.FACEBOOK.classIcon,
      iconIG: SOCIAL_MEDIA.INSTAGRAM.classIcon,
      iconYT: SOCIAL_MEDIA.YOUTUBE.classIcon,
      iconLK: SOCIAL_MEDIA.LINKEDIN.classIcon,
      nameX: SOCIAL_MEDIA.X.name,
      nameFB: SOCIAL_MEDIA.FACEBOOK.name,
      nameIG: SOCIAL_MEDIA.INSTAGRAM.name,
      nameYT: SOCIAL_MEDIA.YOUTUBE.name,
      nameLK: SOCIAL_MEDIA.LINKEDIN.name,
      variantX: SOCIAL_MEDIA.X.variant,
      variantFB: SOCIAL_MEDIA.FACEBOOK.variant,
      variantIG: SOCIAL_MEDIA.INSTAGRAM.variant,
      variantYT: SOCIAL_MEDIA.YOUTUBE.variant,
      variantLK: SOCIAL_MEDIA.LINKEDIN.variant,
      variantOldX: SOCIAL_MEDIA.X.oldVariant,
      subTittle: {
        facebook: {
          subTittle: `${SOCIAL_MEDIA.FACEBOOK.name} Posts`,
          info: "(Range: Last 60 Days)",
        },
        twitter: {
          subTittle: `${SOCIAL_MEDIA.X.name} Posts`,
          info: "(Range: Last 5 Posts)",
        },
        instagram: {
          subTittle: `${SOCIAL_MEDIA.INSTAGRAM.name} Posts`,
          info: "(Range: Last 60 Days)",
        },
        youtube: {
          subTittle: `${SOCIAL_MEDIA.YOUTUBE.name} Videos`,
          info: "(Range: Last 50 Videos)",
        },
        linkedin: {
          subTittle: `${SOCIAL_MEDIA.LINKEDIN.name} Posts`,
          info: "(Range: Last 50 Posts)",
        },
      },
    }
  },
  methods: {
    handler() {
      
    },
  },
};